import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenNewPassword() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="new-password" /></AuthShell>;
}

export default AuthFullScreenNewPassword;
